<div #formRow class="form-group" [ngClass]="{ 'mb-0': noMarginBottom }">
  @if (label && label.length) {
    <label>
      {{ label | translate }}
      @if (tooltipLabel && tooltipLabel.length > 0) {
        <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
      }
    </label>
  }
  <div class="input-group">
    @if (icon && icon.length) {
      <div class="input-group-prepend"></div>
    }
    @if (inputDisabled) {
      <textarea
        class="form-control"
        [cols]="cols"
        [rows]="rows"
        [placeholder]="(placeholder | translate) ?? ''"
        disabled
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.data-cy]="dataCyAttribute"
      ></textarea>
    }
    @if (!inputDisabled) {
      <textarea
        class="form-control"
        #inputArea
        [cols]="cols"
        [rows]="rows"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [placeholder]="(placeholder | translate) ?? ''"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [attr.data-cy]="dataCyAttribute"
      ></textarea>
    }
    @if ((btnLabel && btnLabel.length) || (btnIcon && btnIcon.length)) {
      <div class="input-group-btn">
        <btn
          [label]="btnLabel"
          [title]="btnLabel | translate"
          [classes]="btnClasses"
          [icon]="btnIcon"
          (onEvent)="onBtnClick($event)"
        ></btn>
      </div>
    }
  </div>
</div>
